import React, { useState, useEffect, useRef } from 'react';
import useInterval from '@src/hooks/useInterval';

function useMouseInactiveTime(){
  const [mouseInactiveTime, setMouseInactiveTime] = useState(0);
  const mouseActive = useRef(true);

  const onMouseMove = () => {
    mouseActive.current = false;
    setMouseInactiveTime(0);
  };
  useInterval(() => {
    setMouseInactiveTime(prev => prev + 1);
  }, 1000);

  useEffect(() => {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseleave', onMouseMove);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseleave', onMouseMove);
    };
  }, []);

  return mouseInactiveTime > 60*60;
}

export default useMouseInactiveTime
